import React from "react";
import { ApiRoutes } from "@/apiroutes";
import { Params } from "@remix-run/react";

export const getApi = async (request: Request) => {
  const devMode = process.env.NODE_ENV === "development";
  // In production, use API_URL env var for internal pod-to-pod communication
  // Falls back to public URL if API_URL is not set
  const route = devMode
    ? "http://localhost:5207"
    : process.env.API_URL ?? new URL("/api", request.url).toString();
  const cookies = request.headers.get("Cookie");
  const api = new ApiRoutes(route, cookies);
  return api;
};

export const useApi = () => {
  const [ api, ] = React.useState<ApiRoutes>(new ApiRoutes("/api"));
  return api;
};

export const parseParam = <T>(params: Params<string>, paramName: string): T => {
  if (!params[paramName]) {
    throw new Error(`Invalid param '${paramName}'`);
  }
  return <T>params[paramName];
};
